import * as types from '../mutation-types'
import api from '@/api/achievement'

// initial state
const state = {
    achievements: [],
    loaded: false,
}

const getters = {
    achievements: state => state.achievements,
    achievementsLoaded: state => state.loaded,
}

const actions = {
    getAchievements({ commit }) {
        commit(types.SET_ACHIEVEMENTS_LOADED, false );
        api.getAchievements({_embed: 1},(response) => {
            commit(types.SET_ACHIEVEMENTS, response._embedded.Achievement );
            commit(types.SET_ACHIEVEMENTS_LOADED, true );
        })
    },
    cleanAchievements({commit}) {
        commit(types.SET_ACHIEVEMENTS_LOADED, false );
        commit(types.SET_ACHIEVEMENTS, {} );
    }
}

const mutations = {
    [types.SET_ACHIEVEMENTS] (state, achievements ) {
        state.achievements = achievements.sort((a, b) => {
            return a._embedded.Content.order - b._embedded.Content.order
        })
    },
    [types.SET_ACHIEVEMENTS_LOADED] (state, status ) {
        state.loaded = status
    },
}


export default {
    state,
    getters,
    actions,
    mutations
}


